/** 店舖狀態「全部」的值(對應 ClubStatusEnum.All)，後端視為不過濾 */
export const CLUB_STATUS_ALL = 99;

/** 店舖狀態文字對照(ClubStatusEnum) */
export const CLUB_STATUS_TEXT_MAP = {
    0: '無',
    1: '營運中',
    2: '籌備中',
    3: '已歇業',
};

/** 檢查/補建帳號結果文字對照(ensure-accounts 回應的 status) */
export const ACCOUNT_ENSURE_STATUS_TEXT_MAP = {
    existing: '已存在',
    created: '已建立',
    failed: '失敗',
};
